const themeColors = [
  {
    name: "theme-shade-1",
    type: "hsla",
    values: { h: 0, s: 0, l: 100, a: 1 },
    cssVar: "--color-theme-background--shade-1",
  },
  {
    name: "theme-shade-2",
    type: "hsla",
    values: { h: 0, s: 0, l: 97, a: 1 },
    cssVar: "--color-theme-background--shade-2",
  },
  {
    name: "theme-shade-3",
    type: "hsla",
    values: { h: 0, s: 0, l: 93, a: 1 },
    cssVar: "--color-theme-background--shade-3",
  },
  {
    name: "theme-shade-4",
    type: "hsla",
    values: { h: 0, s: 0, l: 89, a: 1 },
    cssVar: "--color-theme-background--shade-4",
  },
  {
    name: "text-default",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 1 },
    cssVar: "--color-theme-text",
  },
  {
    name: "text-subtle",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.75 },
    cssVar: "--color-theme-text--subtle",
  },
  {
    name: "text-disabled",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.3 },
    cssVar: "--color-theme-text--disabled",
  },
  {
    name: "border",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.2 },
    cssVar: "--color-theme-border",
  },
  {
    name: "opacity-overlay-heavy",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.75 },
    cssVar: "--color-theme-background--overlay-heavy",
  },
  {
    name: "opacity-overlay-light",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.3 },
    cssVar: "--color-theme-background--overlay-light",
  },
  {
    name: "opacity-subtle",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.15 },
    cssVar: "--color-theme-background--subtle",
  },
  {
    name: "opacity-active",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.08 },
    cssVar: "--color-theme-background--active",
  },
  {
    name: "opacity-disabled",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.05 },
    cssVar: "--color-theme-background--disabled",
  },
  {
    name: "opacity-hover",
    type: "hsla",
    values: { h: 0, s: 0, l: 25, a: 0.04 },
    cssVar: "--color-theme-background--hover",
  },
];

const attentionColors = [
  {
    name: "Accent-Active",
    type: "hsla",
    values: { h: 225, s: 89, l: 53, a: 1 },
    cssVar: "--color-ui-accent--active",
  },
  {
    name: "Accent-Default",
    type: "hsla",
    values: { h: 225, s: 100, l: 58, a: 1 },
    cssVar: "--color-ui-accent",
  },
  {
    name: "Accent-Hover",
    type: "hsla",
    values: { h: 225, s: 100, l: 61, a: 1 },
    cssVar: "--color-ui-accent--hover",
  },
  {
    name: "Accent-tone",
    type: "hsla",
    value: "hsla(222, 100%, 63%, 0.13)",
    values: { h: 222, s: 100, l: 63, a: 0.13 },
    cssVar: "--missing",
  },
  {
    name: "Error-Active",
    type: "hsla",
    values: { h: 0, s: 91, l: 47, a: 1 },
    cssVar: "--color-ui-error--active",
  },
  {
    name: "Error-Default",
    type: "hsla",
    values: { h: 0, s: 89, l: 52, a: 1 },
    cssVar: "--color-ui-error",
  },
  {
    name: "Error-Hover",
    type: "hsla",
    values: { h: 0, s: 100, l: 57, a: 1 },
    cssVar: "--color-ui-error--hover",
  },
  {
    name: "Success-Active",
    type: "hsla",
    values: { h: 145, s: 100, l: 29, a: 1 },
    cssVar: "--color-ui-success--active",
  },
  {
    name: "Success-Default",
    type: "hsla",
    values: { h: 145, s: 100, l: 32, a: 1 },
    cssVar: "--color-ui-success",
  },
  {
    name: "Success-Hover",
    type: "hsla",
    values: { h: 145, s: 90, l: 36, a: 1 },
    cssVar: "--color-ui-success--hover",
  },
  {
    name: "Warning-Active",
    type: "hsla",
    values: { h: 25, s: 96, l: 53, a: 1 },
    cssVar: "--color-ui-warning--active",
  },
  {
    name: "Warning-Default",
    type: "hsla",
    values: { h: 25, s: 100, l: 57, a: 1 },
    cssVar: "--color-ui-warning",
  },
  {
    name: "Warning-Hover",
    type: "hsla",
    values: { h: 25, s: 100, l: 61, a: 1 },
    cssVar: "--color-ui-warning--hover",
  },
  {
    name: "Info-Active",
    type: "hsla",
    values: { h: 225, s: 89, l: 53, a: 1 },
    cssVar: "--color-ui-info--active",
  },
  {
    name: "Info-Default",
    type: "hsla",
    values: { h: 225, s: 100, l: 58, a: 1 },
    cssVar: "--color-ui-info",
  },
  {
    name: "Info-Hover",
    type: "hsla",
    values: { h: 225, s: 100, l: 61, a: 1 },
    cssVar: "--color-ui-info--hover",
  },
  {
    name: "Highlight",
    type: "hsla",
    values: { h: 69, s: 100, l: 50, a: 1 },
    cssVar: "--color-ui-highlight",
  },
];

const productColors1 = [
  {
    name: "Electric Dreams-Active",
    type: "hsla",
    values: { h: 214, s: 61, l: 46, a: 1 },
    cssVar: "--color-product-electric-dreams--active",
  },
  {
    name: "Electric Dreams-Default",
    type: "hsla",
    values: { h: 214, s: 59, l: 52, a: 1 },
    cssVar: "--color-product-electric-dreams",
  },
  {
    name: "Electric Dreams-Hover",
    type: "hsla",
    values: { h: 214, s: 65, l: 57, a: 1 },
    cssVar: "--color-product-electric-dreams--hover",
  },
  {
    name: "Event Horizon-Active",
    type: "hsla",
    values: { h: 236, s: 29, l: 45, a: 1 },
    cssVar: "--color-product-event-horizon--active",
  },
  {
    name: "Event Horizon-Default",
    type: "hsla",
    values: { h: 237, s: 26, l: 50, a: 1 },
    cssVar: "--color-product-event-horizon",
  },
  {
    name: "Event Horizon-Hover",
    type: "hsla",
    values: { h: 237, s: 27, l: 56, a: 1 },
    cssVar: "--color-product-event-horizon--hover",
  },
  {
    name: "Extraterrestrial-Active",
    type: "hsla",
    values: { h: 116, s: 38, l: 48, a: 1 },
    cssVar: "--color-product-extraterrestrial--active",
  },
  {
    name: "Extraterrestrial-Default",
    type: "hsla",
    values: { h: 116, s: 37, l: 53, a: 1 },
    cssVar: "--color-product-extraterrestrial",
  },
  {
    name: "Extraterrestrial-Hover",
    type: "hsla",
    values: { h: 117, s: 42, l: 59, a: 1 },
    cssVar: "--color-product-extraterrestrial--hover",
  },
  {
    name: "Fantastic Voyage-Active",
    type: "hsla",
    values: { h: 337, s: 63, l: 38, a: 1 },
    cssVar: "--color-product-fantastic-voyage--active",
  },
  {
    name: "Fantastic Voyage-Default",
    type: "hsla",
    values: { h: 337, s: 57, l: 42, a: 1 },
    cssVar: "--color-product-fantastic-voyage",
  },
  {
    name: "Fantastic Voyage-Hover",
    type: "hsla",
    values: { h: 337, s: 50, l: 47, a: 1 },
    cssVar: "--color-product-fantastic-voyage--hover",
  },
  {
    name: "Forbidden Planet-Active",
    type: "hsla",
    values: { h: 10, s: 66, l: 74, a: 1 },
    cssVar: "--color-product-forbidden-planet--active",
  },
  {
    name: "Forbidden Planet-Default",
    type: "hsla",
    values: { h: 10, s: 80, l: 80, a: 1 },
    cssVar: "--color-product-forbidden-planet",
  },
  {
    name: "Forbidden Planet-Hover",
    type: "hsla",
    values: { h: 10, s: 100, l: 86, a: 1 },
    cssVar: "--color-product-forbidden-planet--hover",
  },
  {
    name: "Future Shock-Active",
    type: "hsla",
    values: { h: 59, s: 87, l: 48, a: 1 },
    cssVar: "--color-product-future-shock--active",
  },
  {
    name: "Future Shock-Default",
    type: "hsla",
    values: { h: 59, s: 88, l: 53, a: 1 },
    cssVar: "--color-product-future-shock",
  },
  {
    name: "Future Shock-Hover",
    type: "hsla",
    values: { h: 59, s: 97, l: 58, a: 1 },
    cssVar: "--color-product-future-shock--hover",
  },
  {
    name: "Giant Leap-Active",
    type: "hsla",
    values: { h: 190, s: 66, l: 56, a: 1 },
    cssVar: "--color-product-giant-leap--active",
  },
  {
    name: "Giant Leap-Default",
    type: "hsla",
    values: { h: 190, s: 74, l: 62, a: 1 },
    cssVar: "--color-product-giant-leap",
  },
  {
    name: "Giant Leap-Hover",
    type: "hsla",
    values: { h: 190, s: 84, l: 67, a: 1 },
    cssVar: "--color-product-giant-leap--hover",
  },
  {
    name: "Ground Control-Active",
    type: "hsla",
    values: { h: 24, s: 53, l: 37, a: 1 },
    cssVar: "--color-product-ground-control--active",
  },
  {
    name: "Ground Control-Default",
    type: "hsla",
    values: { h: 24, s: 47, l: 42, a: 1 },
    cssVar: "--color-product-ground-control",
  },
  {
    name: "Ground Control-Hover",
    type: "hsla",
    values: { h: 24, s: 42, l: 47, a: 1 },
    cssVar: "--color-product-ground-control--hover",
  },
  {
    name: "Luna Dust-Active",
    type: "hsla",
    values: { h: 200, s: 16, l: 48, a: 1 },
    cssVar: "--color-product-luna-dust--active",
  },
  {
    name: "Luna Dust-Default",
    type: "hsla",
    values: { h: 200, s: 15, l: 54, a: 1 },
    cssVar: "--color-product-luna-dust",
  },
  {
    name: "Luna Dust-Active",
    type: "hsla",
    values: { h: 200, s: 15, l: 60, a: 1 },
    cssVar: "--color-product-luna-dust--hover",
  },
  {
    name: "Moon Lagoon-Active",
    type: "hsla",
    values: { h: 186, s: 75, l: 39, a: 1 },
    cssVar: "--color-product-moon-lagoon--active",
  },
  {
    name: "Moon Lagoon-Default",
    type: "hsla",
    values: { h: 186, s: 68, l: 44, a: 1 },
    cssVar: "--color-product-moon-lagoon",
  },
  {
    name: "Moon Lagoon-Hover",
    type: "hsla",
    values: { h: 186, s: 61, l: 49, a: 1 },
    cssVar: "--color-product-moon-lagoon--hover",
  },
  {
    name: "New Horizon-Active",
    type: "hsla",
    values: { h: 44, s: 100, l: 47, a: 1 },
    cssVar: "--color-product-new-horizon--active",
  },
  {
    name: "New Horizon-Default",
    type: "hsla",
    values: { h: 44, s: 100, l: 52, a: 1 },
    cssVar: "--color-product-new-horizon",
  },
  {
    name: "New Horizon-Hover",
    type: "hsla",
    values: { h: 44, s: 99, l: 59, a: 1 },
    cssVar: "--color-product-new-horizon--hover",
  },
];

const productColors2 = [
  {
    name: "Blast Off-Active",
    type: "hsla",
    values: { h: 29, s: 85, l: 54, a: 1 },
    cssVar: "--color-product-blast-off--active",
  },
  {
    name: "Blast Off-Default",
    type: "hsla",
    values: { h: 29, s: 94, l: 59, a: 1 },
    cssVar: "--color-product-blast-off",
  },
  {
    name: "Blast Off-Hover",
    type: "hsla",
    values: { h: 29, s: 100, l: 63, a: 1 },
    cssVar: "--color-product-blast-off--hover",
  },
  {
    name: "Crash Course-Active",
    type: "hsla",
    values: { h: 8, s: 87, l: 61, a: 1 },
    cssVar: "--color-product-crash-course--active",
  },
  {
    name: "Crash Course-Default",
    type: "hsla",
    values: { h: 8, s: 100, l: 67, a: 1 },
    cssVar: "--color-product-crash-course",
  },
  {
    name: "Crash Course-Hover",
    type: "hsla",
    values: { h: 8, s: 100, l: 71, a: 1 },
    cssVar: "--color-product-crash-course--hover",
  },
  {
    name: "Critical Mass-Active",
    type: "hsla",
    values: { h: 346, s: 63, l: 57, a: 1 },
    cssVar: "--color-product-critical-mass--active",
  },
  {
    name: "Critical Mass-Default",
    type: "hsla",
    values: { h: 346, s: 71, l: 62, a: 1 },
    cssVar: "--color-product-critical-mass",
  },
  {
    name: "Critical Mass-Hover",
    type: "hsla",
    values: { h: 346, s: 81, l: 68, a: 1 },
    cssVar: "--color-product-critical-mass--hover",
  },
  {
    name: "Deep Thought-Active",
    type: "hsla",
    values: { h: 257, s: 0, l: 80, a: 1 },
    cssVar: "--color-product-deep-thought--active",
  },
  {
    name: "Deep Thought-Default",
    type: "hsla",
    values: { h: 257, s: 5, l: 74, a: 1 },
    cssVar: "--color-product-deep-thought",
  },
  {
    name: "Deep Thought-Hover",
    type: "hsla",
    values: { h: 257, s: 10, l: 67, a: 1 },
    cssVar: "--color-product-deep-thought--hover",
  },
  {
    name: "Outer Limits-Active",
    type: "hsla",
    values: { h: 197, s: 76, l: 67, a: 1 },
    cssVar: "--color-product-outer-limits--active",
  },
  {
    name: "Outer Limits-Default",
    type: "hsla",
    values: { h: 197, s: 90, l: 74, a: 1 },
    cssVar: "--color-product-outer-limits",
  },
  {
    name: "Outer Limits-Hover",
    type: "hsla",
    values: { h: 197, s: 95, l: 78, a: 1 },
    cssVar: "--color-product-outer-limits--hover",
  },
  {
    name: "Paradise Lost-Active",
    type: "hsla",
    values: { h: 277, s: 26, l: 48, a: 1 },
    cssVar: "--color-product-paradise-lost--active",
  },
  {
    name: "Paradise Lost-Default",
    type: "hsla",
    values: { h: 277, s: 25, l: 54, a: 1 },
    cssVar: "--color-product-paradise-lost",
  },
  {
    name: "Paradise Lost-Hover",
    type: "hsla",
    values: { h: 276, s: 27, l: 59, a: 1 },
    cssVar: "--color-product-paradise-lost--hover",
  },
  {
    name: "Primeval Soup-Active",
    type: "hsla",
    values: { h: 60, s: 85, l: 39, a: 1 },
    cssVar: "--color-product-primeval-soup--active",
  },
  {
    name: "Primeval Soup-Default",
    type: "hsla",
    values: { h: 60, s: 78, l: 44, a: 1 },
    cssVar: "--color-product-primeval-soup",
  },
  {
    name: "Primeval Soup-Hover",
    type: "hsla",
    values: { h: 60, s: 70, l: 49, a: 1 },
    cssVar: "--color-product-primeval-soup--hover",
  },
  {
    name: "Rocky Planet-Active",
    type: "hsla",
    values: { h: 37, s: 18, l: 48, a: 1 },
    cssVar: "--color-product-rocky-planet--active",
  },
  {
    name: "Rocky Planet-Default",
    type: "hsla",
    values: { h: 37, s: 17, l: 54, a: 1 },
    cssVar: "--color-product-rocky-planet",
  },
  {
    name: "Rocky Planet-Hover",
    type: "hsla",
    values: { h: 37, s: 18, l: 60, a: 1 },
    cssVar: "--color-product-rocky-planet--hover",
  },
  {
    name: "Serenity-Active",
    type: "hsla",
    values: { h: 226, s: 42, l: 64, a: 1 },
    cssVar: "--color-product-serene-sea--active",
  },
  {
    name: "Serenity-Default",
    type: "hsla",
    values: { h: 226, s: 46, l: 70, a: 1 },
    cssVar: "--color-product-serene-sea",
  },
  {
    name: "Serenity-Hover",
    type: "hsla",
    values: { h: 226, s: 53, l: 77, a: 1 },
    cssVar: "--color-product-serene-sea--hover",
  },
  {
    name: "Solar Rust-Active",
    type: "hsla",
    values: { h: 35, s: 85, l: 40, a: 1 },
    cssVar: "--color-product-solar-rust--active",
  },
  {
    name: "Solar Rust-Default",
    type: "hsla",
    values: { h: 35, s: 77, l: 45, a: 1 },
    cssVar: "--color-product-solar-rust",
  },
  {
    name: "Solar Rust-Hover",
    type: "hsla",
    values: { h: 35, s: 70, l: 50, a: 1 },
    cssVar: "--color-product-solar-rust--hover",
  },
  {
    name: "Space Invader-Active",
    type: "hsla",
    values: { h: 160, s: 57, l: 33, a: 1 },
    cssVar: "--color-product-space-invader--active",
  },
  {
    name: "Space Invader-Default",
    type: "hsla",
    values: { h: 160, s: 51, l: 38, a: 1 },
    cssVar: "--color-product-space-invader",
  },
  {
    name: "Space Invader-Hover",
    type: "hsla",
    values: { h: 160, s: 46, l: 42, a: 1 },
    cssVar: "--color-product-space-invader--hover",
  },
  {
    name: "Space Oddity-Active",
    type: "hsla",
    values: { h: 44, s: 40, l: 49, a: 1 },
    cssVar: "--color-product-space-oddity--active",
  },
  {
    name: "Space Oddity-Default",
    type: "hsla",
    values: { h: 44, s: 43, l: 55, a: 1 },
    cssVar: "--color-product-space-oddity",
  },
  {
    name: "Space Oddity-Hover",
    type: "hsla",
    values: { h: 44, s: 47, l: 60, a: 1 },
    cssVar: "--color-product-space-oddity--hover",
  },
  {
    name: "Sun Maker-Active",
    type: "hsla",
    values: { h: 50, s: 96, l: 48, a: 1 },
    cssVar: "--color-product-sun-maker--active",
  },
  {
    name: "Sun Maker-Default",
    type: "hsla",
    values: { h: 50, s: 97, l: 53, a: 1 },
    cssVar: "--color-product-sun-maker",
  },
  {
    name: "Sun Maker-Hover",
    type: "hsla",
    values: { h: 50, s: 100, l: 59, a: 1 },
    cssVar: "--color-product-sun-maker--hover",
  },
  {
    name: "Terra Form-Active",
    type: "hsla",
    values: { h: 85, s: 61, l: 45, a: 1 },
    cssVar: "--color-product-terra-form--active",
  },
  {
    name: "Terra Form-Default",
    type: "hsla",
    values: { h: 85, s: 55, l: 50, a: 1 },
    cssVar: "--color-product-terra-form",
  },
  {
    name: "Terra Form-Hover",
    type: "hsla",
    values: { h: 85, s: 60, l: 55, a: 1 },
    cssVar: "--color-product-terra-form--hover",
  },
  {
    name: "Tiny Clanger-Active",
    type: "hsla",
    values: { h: 340, s: 68, l: 71, a: 1 },
    cssVar: "--color-product-tiny-clanger--active",
  },
  {
    name: "Tiny Clanger-Default",
    type: "hsla",
    values: { h: 340, s: 82, l: 78, a: 1 },
    cssVar: "--color-product-tiny-clanger",
  },
  {
    name: "Tiny Clanger-Hover",
    type: "hsla",
    values: { h: 339, s: 100, l: 84, a: 1 },
    cssVar: "--color-product-tiny-clanger--hover",
  },
];

export { themeColors, attentionColors, productColors1, productColors2 };
